import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaBensImoveis: ['administracao'],
    setClassificacaoConsultaBensImoveis: ['classificacao'],
    setCodigoSituacaoLegalConsultaBensImoveis: ['codigoSituacaoLegal'],
    setIdentificacaoConsultaBensImoveis: ['identificacao'],
    setEnderecoConsultaBensImoveis: ['endereco'],
    limpaFiltroConsultaBensImoveis: [],
    receberFiltroConsultaBensImoveis: ['filtroRecebido'],
    setStatusConsultaBensImoveis: ['status'],
})

const INITIAL_STATE = {
    administracao: [],
    classificacao: [],
    codigoSituacaoLegal: [],
    identificacao: '',
    endereco: '',
    status: { label: '', value: '' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setClassificacao = (state = INITIAL_STATE, action) => {
    return { ...state, classificacao: action.classificacao }
}

const setCodigoSituacaoLegal = (state = INITIAL_STATE, action) => {
    return { ...state, codigoSituacaoLegal: action.codigoSituacaoLegal }
}

const setIdentificacao = (state = INITIAL_STATE, action) => {
    return { ...state, identificacao: action.identificacao }
}

const setEndereco = (state = INITIAL_STATE, action) => {
    return { ...state, endereco: action.endereco }
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_BENS_IMOVEIS]: setAdministracao,
    [Types.SET_CLASSIFICACAO_CONSULTA_BENS_IMOVEIS]: setClassificacao,
    [Types.SET_CODIGO_SITUACAO_LEGAL_CONSULTA_BENS_IMOVEIS]: setCodigoSituacaoLegal,
    [Types.SET_IDENTIFICACAO_CONSULTA_BENS_IMOVEIS]: setIdentificacao,
    [Types.SET_ENDERECO_CONSULTA_BENS_IMOVEIS]: setEndereco,
    [Types.LIMPA_FILTRO_CONSULTA_BENS_IMOVEIS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_BENS_IMOVEIS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_BENS_IMOVEIS]: setStatus,
})
